module.exports = __webpack_public_path__ + "static/media/s_v8_t7_1.7b391247.mp3";